module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0053.jpg?v=6cca49ea";